<div class="avi-full-modal-preview-message">
    <div class="avi-full-modal-preview-message__content">
        <cds-icon 
            [shape]="statusIcon" 
            class="avi-full-modal-preview-message__icon"
            aria-label="Security Shield">
        </cds-icon>
        <span class="avi-full-modal-preview-message__text">{{ header }}</span>
        <div class="avi-full-modal-preview-message__badge">
            <span class="avi-full-modal-preview-message__badge-text">{{ statusText }}</span>
            <avi-tooltip-icon-with-content-wrapper
                *ngIf="tooltipText"
                shape="info-circle"
                size="14"
                iconClassName="avi-full-modal-preview-message__info-icon"
                [aria-label]="l10nKeys.informationLabel">
                <div>{{ tooltipText }}</div>
            </avi-tooltip-icon-with-content-wrapper>
            <cds-icon 
                *ngIf="!tooltipText"
                shape="info-circle" 
                class="avi-full-modal-preview-message__info-icon"
                [aria-label]="l10nKeys.informationLabel">
            </cds-icon>
        </div>
    </div>
</div>
